export default class PaymentPreferences {
  constructor(data = {}) {
    this.paymentType = data.paymentType;
    this.priority = data.priority;
  }
}
